<template>
    <div>
        <md-button class="md-primary pull-right header-button" @click="updateStop" :disabled="!teamMembers.length">
            Edit
        </md-button>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { CUSTOMER_DETAILS_DEFAULTS } from '@/utils/defaults';
import CreateCustomerModal from '@/pages/Customer/Modals/CreateCustomerModal';
import UpdateStopModal from './UpdateStopModal';

export default {
    name: 'UpdateStop',
    mixins: [GeneralMixin],
    props: {
        teamMembers: {
            type: Array,
            default: () => []
        },
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            stopDetails: {}
        };
    },
    methods: {
        async handleCreateCustomer() {
            const customerDetails = { ...CUSTOMER_DETAILS_DEFAULTS(), teamRegionId: this.user.teamRegionId || null };
            const result = await this.$modal.showWithoutAutoClose(CreateCustomerModal, {
                customerDetails,
                version: 'v2'
            });
            if (result.status !== 'ok') {
                return;
            }
            const { customerId } = result.result;
            this.stopDetails.customerId = customerId;
            this.updateStop();
        },
        updateStop() {
            this.stopDetails = Object.assign({}, this.data);

            this.$modal
                .show(UpdateStopModal, {
                    members: this.teamMembers,
                    stop: this.stopDetails,
                    createCustomer: this.handleCreateCustomer
                })
                .then((response) => {
                    if (response.toLowerCase() === 'ok') 
                        this.emitStopUpdated();
                    this.$modal.hide();
                });
        },
        emitStopUpdated() {
            this.$emit('stopUpdated');
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-btn {
    margin-right: 16px;
}
</style>
